import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/no-array-index-key */
import Plot from './Plot';
import { Annotations, Arrow, Circle, Ellipse, Group, Line, Rectangle, Shape, Text, } from './components/Annotations/Annotation';
import Axis from './components/Axis';
import ParallelAxis from './components/Axis/ParallelAxis';
import Legend from './components/Legend';
import LineSeries from './components/LineSeries';
import ScatterSeries from './components/ScatterSeries';
export default function PlotObject({ plot: { dimensions, svg = {}, seriesViewportStyle, axes, content, legend, colorScheme, }, children, }) {
    const { className: svgClassName, id: svgId, style: svgStyle, ...svgProps } = svg;
    return (_jsxs(Plot, Object.assign({ colorScheme: colorScheme, seriesViewportStyle: seriesViewportStyle }, dimensions, { svgClassName: svgClassName, svgId: svgId, svgStyle: svgStyle }, svgProps, { children: [axes.map((axisProps) => {
                switch (axisProps.type) {
                    case 'main': {
                        const { type, ...props } = axisProps;
                        return _jsx(Axis, Object.assign({}, props), axisProps.position);
                    }
                    case 'secondary': {
                        const { type, ...props } = axisProps;
                        return _jsx(ParallelAxis, Object.assign({}, props), `secondary-${props.id}`);
                    }
                    default: {
                        return null;
                    }
                }
            }),
            legend !== undefined ? _jsx(Legend, Object.assign({}, legend), void 0) : null,
            content.map((contentProps, i) => {
                switch (contentProps.type) {
                    case 'line': {
                        const { type, ...props } = contentProps;
                        return _jsx(LineSeries, Object.assign({}, props), `${type}-${i}`);
                    }
                    case 'scatter': {
                        const { type, ...props } = contentProps;
                        return _jsx(ScatterSeries, Object.assign({}, props), `${type}-${i}`);
                    }
                    case 'annotation': {
                        return (_jsx(Annotations, { children: contentProps.children.map(annotationMap) }, `${contentProps.type}-${i}`));
                    }
                    default: {
                        return null;
                    }
                }
            }),
            children && _jsx(Annotations, { children: children }, void 0)] }), void 0));
}
function annotationMap(annotationProps, index) {
    switch (annotationProps.type) {
        case 'arrow': {
            const { type, ...props } = annotationProps;
            return _jsx(Arrow, Object.assign({}, props), `${type}-${index}`);
        }
        case 'circle': {
            const { type, ...props } = annotationProps;
            return _jsx(Circle, Object.assign({}, props), `${type}-${index}`);
        }
        case 'ellipse': {
            const { type, ...props } = annotationProps;
            return _jsx(Ellipse, Object.assign({}, props), `${type}-${index}`);
        }
        case 'line': {
            const { type, ...props } = annotationProps;
            return _jsx(Line, Object.assign({}, props), `${type}-${index}`);
        }
        case 'rectangle': {
            const { type, ...props } = annotationProps;
            return _jsx(Rectangle, Object.assign({}, props), `${type}-${index}`);
        }
        case 'shape': {
            const { type, ...props } = annotationProps;
            return _jsx(Shape, Object.assign({}, props), `${type}-${index}`);
        }
        case 'text': {
            const { type, ...props } = annotationProps;
            return _jsx(Text, Object.assign({}, props), `${type}-${index}`);
        }
        case 'group': {
            const { type, children, ...props } = annotationProps;
            return (_jsx(Group, Object.assign({}, props, { children: children.map(annotationMap) }), `${type}-${index}`));
        }
        default: {
            return null;
        }
    }
}
//# sourceMappingURL=PlotObject.js.map